import { Button as JoyBtn } from "@mui/joy";

export default function Button(props: any) {
	const { sx: sxProp, ...rest } = props;
	return (
		<JoyBtn
			{...rest}
			sx={{
				"--Button-radius": "4px",
				borderRadius: "4px",
				fontWeight: "500",
				border: "1px solid",
				borderColor: "divider",
				...sxProp,
			}}
		/>
	);
}
